<template>
  <div id="rwa_details_div" class="rwa_details_div">

    <div class="rwa_details_page_01">
      <Menu/>
    </div>

    <div id="rwa_details_page_02" ref="rwa_details_page_02" class="rwa_details_page_02">

      <div class="rwa_details_page_021" v-if="projectObjInfo">

        <img class="rwa_details_page_021_bj01" src="../../assets/images/Ellipse_bjl.png"/>
        <img class="rwa_details_page_021_bj03" src="../../assets/images/Ellipse_bjr.png"/>

        <div class="rwa_details_page_0211">
          <div class="rwa_details_page_02111">
            <div class="rwa_details_page_021111">
              <img v-if="projectObjInfo.images_group1 && projectObjInfo.images_group1.length > 0 && imgSelIndex === -1" :src="imgHost + projectObjInfo.images_group1[0]"/>
              <img v-if="projectObjInfo.images_group2 && projectObjInfo.images_group2.length > 0 && imgSelIndex >= 0" :src="imgHost + projectObjInfo.images_group2[imgSelIndex]"/>
              <img v-if="projectObjInfo.images_group1.length <= 0 && projectObjInfo.images_group2.length <= 0" src="" style="width: 680px; height: 320px;" />
            </div>
            <div v-if="projectObjInfo.images_group2 && projectObjInfo.images_group2.length > 0" class="rwa_details_page_021112">
              <img v-if="projectObjInfo.images_group1 && projectObjInfo.images_group1.length > 0"
                   :class="imgSelIndex === -1 ? 'rwa_details_page_021112_select' : ''"
                   @click="imgSelIndex = -1"
                   :src="imgHost + projectObjInfo.images_group1[0]"/>

              <img v-for="(img, index) in projectObjInfo.images_group2" :key="index"
                   :class="imgSelIndex === index ? 'rwa_details_page_021112_select' : ''"
                   @click="imgSelIndex = index"
                   :src="imgHost + img"/>
            </div>

            <div v-if="projectObjInfo.images_group1 && projectObjInfo.images_group1.length > 0 && projectObjInfo.images_group2.length <= 0" class="rwa_details_page_021112">
              <img :class="imgSelIndex === -1 ? 'rwa_details_page_021112_select' : ''"
                   @click="imgSelIndex = -1"
                   :src="imgHost + projectObjInfo.images_group1[0]"/>
            </div>
          </div>

          <div v-if="projectStatus === 0" class="rwa_details_page_0211_biaoqian">
            待开始
          </div>
          <div v-if="projectStatus === 1" class="rwa_details_page_0211_biaoqian">
            正在进行中
          </div>
          <div v-if="projectStatus === 2" class="rwa_details_page_0211_biaoqian rwa_details_page_0211_biaoqian_end">
            已结束
          </div>

          <div class="rwa_details_page_02112">
            <div class="rwa_details_page_021121">{{ projectObjInfo.name }}</div>
            <div class="rwa_details_page_021122">
              <div class="rwa_details_page_0211221">距离结束</div>
              <div class="rwa_details_page_0211222">
                <div>{{ tian }}</div> &nbsp;&nbsp;:&nbsp;&nbsp;
                <div>{{ shi }}</div> &nbsp;&nbsp;:&nbsp;&nbsp;
                <div>{{ fen }}</div> &nbsp;&nbsp;:&nbsp;&nbsp;
                <div>{{ miao }}</div>
              </div>
              <div class="rwa_details_page_0211223">
                <span>起 拍 价</span>
                <div>{{ setDecimal(projectObjInfo.start_price / 1e18, 6) }} BNB</div>
              </div>
              <div class="rwa_details_page_0211224">
                <span>出价(BNB)</span>
                <div>
                  <el-input-number
                      v-model="priceNum"
                      controls-position="right"
                      @change="handleChange"
                      :min="parseFloat(setDecimal(projectObjInfo.current_price / 1e18, 6))"
                      :step="tickPrice"
                  ></el-input-number>
                </div>
              </div>
            </div>

            <div class="rwa_details_page_021123"
                 v-if="$store.state.accounts.length <= 0"
                 @click="toConnectWalletDetails()">Connect</div>

            <div class="rwa_details_page_021123"
                 v-if="$store.state.accounts.length > 0 && projectStatus < 2"
                 @click="onProjectBidding()">Bidding</div>

            <div class="rwa_details_page_021123" style="background: #5a5a5a; cursor: not-allowed"
                 v-if="$store.state.accounts.length > 0 && projectStatus >= 2"
                 @click="onProjectBidding()">Ended</div>

            <div class="rwa_details_page_021124">
              <div class="rwa_details_page_0211241">
                <span>竞价周期:</span>
                <div>{{setDecimal((projectObjInfo.end_time - projectObjInfo.start_time) / 86400, 3)}} 天</div>
              </div>
              <div class="rwa_details_page_0211242">
                <span>最低加价幅度:</span>
                <div>{{ tickPrice }} BNB</div>
              </div>
              <div class="rwa_details_page_0211243">
                <span>每次加价延时周期:</span>
                <div>24小时</div>
              </div>
            </div>
          </div>
        </div>

        <div class="rwa_details_page_0212_anniu">
          <div :class="mobSelIndex === 0 ? 'rwa_details_page_0212_select' : 'rwa_details_page_0212_anniu01'"
               @click="mobSelIndex = 0">拍卖信息</div>
          <div :class="mobSelIndex === 1 ? 'rwa_details_page_0212_select' : 'rwa_details_page_0212_anniu02'"
               @click="mobSelIndex = 1">竞买记录</div>
        </div>

        <div class="rwa_details_page_0212 com">
          <div class="rwa_details_page_02121">
            <div class="rwa_details_page_021211">
              <video controls="controls" width="100%">
                <source :src="imgHost + projectObjInfo.videos[0]" type="video/mp4">
                <source :src="imgHost + projectObjInfo.videos[0]" type="video/webm">
                您的浏览器不支持 HTML5 视频标签!
              </video>
            </div>
            <div class="rwa_details_page_021212">鉴定证书</div>
            <img class="rwa_details_page_021213" :src="imgHost + projectObjInfo.images_group3[0]"/>
<!--            <div class="rwa_details_page_021214">-->
<!--              <el-carousel indicator-position="outside" height="350px">-->
<!--                <el-carousel-item v-for="(img, item) in projectObjInfo.images_group1" :key="item">-->
<!--                  <img :src="imgHost + img"/>-->
<!--                </el-carousel-item>-->
<!--              </el-carousel>-->
<!--            </div>-->
            <div class="rwa_details_page_021215">
              <div class="rwa_details_page_0212151">藏品详情</div>
              <div class="rwa_details_page_0212152" v-html="projectObjInfo.description">
<!--                {{ projectObjInfo.description }}-->
              </div>
            </div>
          </div>

          <div class="rwa_details_page_02122">
            <div class="rwa_details_page_021221">竞买记录</div>
            <div class="rwa_details_page_021222">
              <div class="rwa_details_page_0212221">地址</div>
              <div class="rwa_details_page_0212222">出价金额</div>
              <div class="rwa_details_page_0212223">时间</div>
            </div>
            <div class="rwa_details_page_021223" v-for="(history, key) in projectObjInfo.bidding_history" :key="key">
              <div class="rwa_details_page_0212231">{{ cutAccount(history.bidder, 5) }}</div>
              <div class="rwa_details_page_0212232">{{ setDecimal(history.price/1e18, 6) }} BNB</div>
              <div class="rwa_details_page_0212233">{{ toTextDate(history.timestamp, true) }}</div>
            </div>
          </div>
        </div>

        <div class="rwa_details_page_0212 mob">
          <div class="rwa_details_page_02121" v-if="mobSelIndex === 0">
            <div class="rwa_details_page_021211">
              <video controls="controls" width="100%">
                <source :src="imgHost + projectObjInfo.videos[0]" type="video/mp4">
                <source :src="imgHost + projectObjInfo.videos[0]" type="video/webm">
                您的浏览器不支持 HTML5 视频标签!
              </video>
            </div>
            <div class="rwa_details_page_021212">鉴定证书</div>
            <img class="rwa_details_page_021213" :src="imgHost + projectObjInfo.images_group3[0]"/>
<!--            <div class="rwa_details_page_021214">-->
<!--              <el-carousel indicator-position="outside" height="350px">-->
<!--                <el-carousel-item v-for="(img, item) in projectObjInfo.images_group1" :key="item">-->
<!--                  <img :src="imgHost + img"/>-->
<!--                </el-carousel-item>-->
<!--              </el-carousel>-->
<!--            </div>-->
            <div class="rwa_details_page_021215">
              <div class="rwa_details_page_0212151">藏品详情</div>
              <div class="rwa_details_page_0212152" v-html="projectObjInfo.description">
<!--                {{ projectObjInfo.description }}-->
              </div>
            </div>
          </div>

          <div class="rwa_details_page_02122" v-if="mobSelIndex === 1">
            <div class="rwa_details_page_021221">竞买记录</div>
            <div class="rwa_details_page_021222">
              <div class="rwa_details_page_0212221">地址</div>
              <div class="rwa_details_page_0212222">出价金额</div>
              <div class="rwa_details_page_0212223">时间</div>
            </div>
            <div class="rwa_details_page_021223" v-for="(history, key) in projectObjInfo.bidding_history" :key="key">
              <div class="rwa_details_page_0212231">{{ cutAccount(history.bidder, 5) }}</div>
              <div class="rwa_details_page_0212232">{{ setDecimal(history.price/1e18, 6) }} BNB</div>
              <div class="rwa_details_page_0212233">{{ toTextDate(history.timestamp, true) }}</div>
            </div>
          </div>
        </div>

      </div>

      <div class="rwa_details_page_03">
        <Bottom/>
      </div>
    </div>

  </div>
</template>

<script>
import {
  cutAccount,
  lang,
  BigNumber,
  BigNumberStr,
  BigNumberMul,
  BigNumberDiv,
  BigNumberAdd,
  BigNumberSub
} from '../../tools/index';

import transfer from "../../tools/transfer";
import Menu from "../../components/Menu";
import Bottom from "../../components/Bottom";
import * as metaMaskTools from "../../tools/chain";

import {
  debug,
  uploadHost
} from "@/config";
import { mixin1 } from "@/tools/mixins";
import { setDecimal, conversionTimestampFormatObj, toTextDate } from "@/tools/toolUtils";

export default {
  name: "Details",
  components: { Menu, Bottom },
  mixins: [mixin1],
  data() {
    return {
      imgHost: uploadHost,
      timeNum: 0,
      tian: 0,
      shi: 0,
      fen: 0,
      miao: 0,
      priceNum: 0,
      tickPrice: 0,
      countdownInterval: null,
      mobSelIndex: 0,
      imgSelIndex: -1,
      projectId: null,
      projectObjInfo: null,
      projectStatus: 0,
      isExecuting: false,  // 标记方法是否正在执行
      intervalId: null     // 存储定时器ID
    };
  },
  created() {
    this.projectId = this.$route.query.projectId;

    setTimeout(() => {
      this.onAccountsChanged();
    }, 1000);

    transfer.$on("initDetailsPageData", () => {
      this.initDetailsPageData();
    });
  },
  mounted() {
    this.initDetailsPageData();

    this.conversionTimestampFormatObj();

    // 启动定时器
    this.intervalId = setInterval(() => {
      if (!this.isExecuting) {
        this.executeWithInterval();
      }
    }, 5000);
  },
  watch: {
  },
  beforeDestroy() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
  methods: {
    lang(key){
      return lang(key);
    },
    cutAccount(text, num) {
      return cutAccount(text, num);
    },
    setDecimal(num, numDecimalMax) {
      return setDecimal(num, numDecimalMax, false, false);
    },
    toTextDate(timestamp, isAll) {
      if (isAll) {
        return toTextDate(timestamp).substr(0, 16);
      } else {
        return toTextDate(timestamp).substr(5, 11);
      }
    },
    conversionTimestampFormatObj(time) {
      if (!time) {
        time = this.timeNum;
      }
      let timeObj = conversionTimestampFormatObj(time);

      this.tian = timeObj.tian;
      this.shi = timeObj.shi;
      this.fen = timeObj.fen;
      this.miao = timeObj.miao;

      // 清除之前的定时器（如果有）
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
      }

      // 设置新的定时器
      this.countdownInterval = setInterval(() => {
        if (this.timeNum > 0) {
          this.timeNum -= 1;
          // 更新显示的时间
          let timeObj = conversionTimestampFormatObj(this.timeNum);
          this.tian = timeObj.tian;
          this.shi = timeObj.shi;
          this.fen = timeObj.fen;
          this.miao = timeObj.miao;
        } else {
          this.projectStatus = 2;
          // 倒计时结束，清除定时器
          clearInterval(this.countdownInterval);
        }
      }, 1000);
    },
    openConnectWallet() {
      this.$store.commit('setState', {
        connectWalletShow: true
      });
    },
    toConnectWalletDetails() {
      this.$message.warning(lang('qxljqb'));

      this.openConnectWallet();
    },
    async initRefreshNetwork() {
      await metaMaskTools.initParams().then(() => {});
    },
    async onRefresh(accounts) {
      await this.$store.commit('setState', {
        accounts
      });

      await this.initDetailsPageData();
    },
    async executeWithInterval() {
      this.isExecuting = true;
      try {
        await this.initDetailsPageData();
      } catch (error) {
        console.error('Error executing initDetailsPageData:', error);
      } finally {
        this.isExecuting = false;
      }
    },
    initDetailsPageData() {
      if (this.$route.query.projectId) {
        this.projectId = this.$route.query.projectId;
      }

      try {
        this.$http.getProjectInfo(this.projectId).then(res => {

          console.log("getProjectInfo:" + JSON.stringify(res));

          if (res.success) {
            this.projectObjInfo = {
              images_group1: res.data.images_group1 || [],
              videos: res.data.videos || [],
              ...res.data
            };

            if (this.projectObjInfo.images_group1.length <= 0) {
              this.imgSelIndex = 0;
            }

            this.tickPrice = parseFloat(this.setDecimal(this.projectObjInfo.tick / 1e18, 6));

            const timeNum = Date.now() / 1000;
            const startTime = this.projectObjInfo.start_time;
            const endTime = this.projectObjInfo.end_time;
            const status = this.projectObjInfo.status;

            // 倒计时
            if (status === 'active') {
              this.timeNum = endTime - parseInt((timeNum).toString());

              if (this.timeNum < 0) {
                this.timeNum = 0;
              }
            } else {
              this.timeNum = 0;
            }
            // 价格
            const indexPrice = this.setDecimal(this.projectObjInfo.current_price / 1e18, 6);
            if (this.priceNum < indexPrice) {
              this.priceNum = indexPrice;
            }

            // 状态
            if (status === 'ended') {
              this.projectStatus = 2; // 结束
            } else if (status === 'active' && startTime > timeNum) {
              this.projectStatus = 0; // 待开始
            } else if (status === 'active' && startTime <= timeNum && endTime > timeNum) {
              this.projectStatus = 1; // 进行中
            } else {
              this.projectStatus = 2; // 结束
            }
          } else {
            this.$message.warning('Service Error!');
          }

        }).catch(err => {
          console.log(err);
        });
      } catch (e) {
        console.log(e);
      }
    },
    async onProjectBidding() {
      try {
        if (this.projectId < 0) {
          this.$message.warning('Data error!');
          return;
        }

        if (this.projectStatus === 0) {
          this.$message.warning('Auction has not started yet!');
          return;
        } else if (this.projectStatus === 2) {
          this.$message.warning('The auction has ended!');
          return;
        }

        let startPrice = parseFloat(this.setDecimal(this.projectObjInfo.current_price / 1e18, 6)) + this.tickPrice;
        startPrice = parseFloat(this.setDecimal(startPrice, 6));

        if (this.priceNum < startPrice) {
          this.$message.warning('The bid cannot be lower than the minimum bid!');
          return;
        }

        await metaMaskTools.bidding([this.projectId], this.priceNum).then(async (data) => {
          await this.initDetailsPageData();
        }).catch(err => {
          const h = this.$createElement;
          this.$notify.error({
            title: '错误',
            message: h('div', { style: 'color: red; width: 320px; text-align: left;'}, err.message),
            duration: 0
          });
        });
      } catch (e) {
        console.log(e);
      }
    },
    handleChange(value) {
      console.log(value);
    },
    toIndex() {
      this.$router.push({
        path: '/index',
      });
    },
  }
};
</script>

<style scoped lang="less">
.rwa_details_div {
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  .rwa_details_page_01 {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
  .rwa_details_page_02::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
  .rwa_details_page_02 {
    overflow-y: auto;
    position: absolute;
    width: 100%;
    top: 84px;
    bottom: 0;
    background: #151515;
    .rwa_details_page_021 {
      display: flex;
      flex-direction: column;
      align-items: center;
      flex-wrap: nowrap;
      justify-content: flex-start;
      position: relative;
      .rwa_details_page_021_bj01 {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 0;
        height: 100%;
        max-height: 880px;
        @media (max-width: 767px){
          max-height: 720px;
        }
      }
      .rwa_details_page_021_bj03 {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 0;
        max-width: 60%;
        @media (max-width: 767px){
          max-width: 45%;
          display: none;
        }
      }
      .rwa_details_page_0211 {
        position: relative;
        display: flex;
        padding: 30px 20px;
        align-items: flex-start;
        gap: 32px;
        border-radius: 16px;
        background: rgba(39, 39, 39, 0.50);
        margin: 60px 0 50px 0;

        @media (max-width: 767px) {
          width: 100%;
          align-items: center;
          flex-direction: column;
          flex-wrap: nowrap;
          justify-content: flex-start;
        }
        .rwa_details_page_02111 {
          display: flex;
          flex-direction: column;
          flex-wrap: nowrap;
          justify-content: flex-start;
          align-items: flex-start;

          @media (max-width: 767px) {
            width: 100%;
          }
          .rwa_details_page_021111 {
            @media (max-width: 767px) {
              width: 100%;
            }

            img {
              width: 680px;
              border-radius: 10px;

              @media (max-width: 767px) {
                width: 90%;
                margin-left: 5%;
              }
            }
          }
          .rwa_details_page_021112 {
            width: 680px;
            height: auto;
            overflow-y: auto;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: flex-start;

            @media (max-width: 767px) {
              width: 90%;
              margin-left: 5%;
              overflow-y: auto;
              height: 100px;
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              align-items: center;
              justify-content: flex-start;
            }
            img {
              width: 120px;
              margin: 25px 10px 0 0;
              border-radius: 10px;
              cursor: pointer;

              @media (max-width: 767px) {
                width: 80px;
                margin: 10px 8px 0 0;
              }
            }
            .rwa_details_page_021112_select {
              border-radius: 4.096px;
              border: 2px solid #20944B;
            }
          }
        }
        .rwa_details_page_0211_biaoqian {
          position: absolute;
          right: 0;
          top: 20px;
          display: flex;
          padding: 8px 15px;
          justify-content: center;
          align-items: center;
          gap: 10px;
          border-radius: 100px 0 0 100px;
          background: #20944B;
          color: white;

          @media (max-width: 767px) {
            right: 0;
            top: auto !important;
            bottom: 390px;
          }
        }
        .rwa_details_page_0211_biaoqian_end {
          background: #C29C6C !important;
        }
        .rwa_details_page_02112 {
          width: 340px;

          @media (max-width: 767px) {
            width: 90%;
          }
          .rwa_details_page_021121 {
            color: #FFF;
            font-family: Roboto;
            font-size: 24px;
            font-style: normal;
            font-weight: 700;
            line-height: 32px; /* 133.333% */
          }
          .rwa_details_page_021122 {
            display: flex;
            flex-direction: column;
            flex-wrap: nowrap;
            align-items: flex-start;
            justify-content: flex-start;
            margin: 30px 0;
            .rwa_details_page_0211221 {
              color: #999;
              font-family: Inter;
              font-size: 16px;
              font-style: normal;
              font-weight: 400;
              line-height: normal;
              margin-bottom: 10px;
            }
            .rwa_details_page_0211222 {
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              justify-content: flex-start;
              align-items: center;
              color: white;

              @media (max-width: 767px) {
                zoom: 1.25;
              }
              div {
                display: flex;
                width: 50px;
                height: 45px;
                padding: 7px 1px;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                gap: 10px;
                border-radius: 8px;
                background: #3D3D3D;
              }
            }
            .rwa_details_page_0211223 {
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              align-items: center;
              justify-content: flex-start;
              margin: 20px 0;
              span {
                width: 100px;
                color: #999;
                font-family: Inter;
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
              }
              div {
                color: #20944B;
                font-family: Inter;
                font-size: 20px;
                font-style: normal;
                font-weight: 600;
                line-height: normal;
              }
            }
            .rwa_details_page_0211224 {
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              justify-content: flex-start;
              align-items: center;
              span {
                width: 100px;
                color: #999;
                font-family: Inter;
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
              }
              div {
                width: 170px;

                @media (max-width: 767px) {
                  zoom: 1.2;
                }
              }
            }
          }
          .rwa_details_page_021123 {
            display: flex;
            padding: 8px 28px;
            justify-content: center;
            align-items: center;
            gap: 10px;
            align-self: stretch;
            border-radius: 8px;
            background: #20944B;
            color: #FFF;
            text-align: center;
            font-family: "Plus Jakarta Sans";
            font-size: 16px;
            font-style: normal;
            font-weight: 700;
            line-height: 30px; /* 187.5% */
            cursor: pointer;
            margin: 25px 0;

            @media (max-width: 767px) {
              height: 50px;
            }
          }
          .rwa_details_page_021124 {
            display: flex;
            padding: 10px 20px;
            flex-direction: column;
            align-items: flex-start;
            gap: 14px;
            align-self: stretch;
            border-radius: 8px;
            background: #313131;
            .rwa_details_page_0211241 {
              width: 100%;
              height: 40px;
              margin-top: -10px;
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              justify-content: space-between;
              align-items: center;
              border-bottom: 1.5px solid #666666;
              span {
                color: #999;
                font-family: Inter;
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
              }
              div {
                color: #FFF;
                font-family: Inter;
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
              }
            }
            .rwa_details_page_0211242 {
              width: 100%;
              height: 43px;
              margin-top: -15px;
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              justify-content: space-between;
              align-items: center;
              border-bottom: 1.5px solid #666666;
              span {
                color: #999;
                font-family: Inter;
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
              }
              div {
                color: #FFF;
                font-family: Inter;
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
              }
            }
            .rwa_details_page_0211243 {
              width: 100%;
              margin-top: -5px;
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              justify-content: space-between;
              align-items: center;
              span {
                color: #999;
                font-family: Inter;
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
              }
              div {
                color: #FFF;
                font-family: Inter;
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
              }
            }
          }
        }
      }
      .rwa_details_page_0212_anniu {
        display: none;
        @media (max-width: 767px) {
          display: flex;
          height: 50px;
          padding: 0 5px;
          justify-content: space-between;
          align-items: center;
          align-self: stretch;
          border-radius: 13px;
          background: #232323;

          width: 90%;
          margin-left: 5%;
          margin-top: -20px;
          margin-bottom: 30px;
        }
        .rwa_details_page_0212_anniu01 {
          color: #999;
          text-align: center;
          font-family: Inter;
          font-size: 16px;
          font-style: normal;
          font-weight: 600;
          line-height: normal;
          width: 50%;
          cursor: pointer;
        }
        .rwa_details_page_0212_anniu02 {
          color: #999;
          text-align: center;
          font-family: Inter;
          font-size: 16px;
          font-style: normal;
          font-weight: 600;
          line-height: normal;
          width: 50%;
          cursor: pointer;
        }
        .rwa_details_page_0212_select {
          display: flex;
          height: 45px;
          padding: 8px 15px;
          font-family: Inter;
          font-weight: 600;
          justify-content: center;
          align-items: center;
          gap: 10px;
          flex: 1 0 0;
          border-radius: 10px;
          color: white;
          background: #20944B;
          cursor: pointer;
        }
      }
      .rwa_details_page_0212 {
        display: flex;
        padding: 20px;
        align-items: flex-start;
        gap: 20px;
        border-radius: 16px;
        background: #272727;
        margin-bottom: 80px;

        @media (max-width: 767px) {
          width: 100%;
        }
        .rwa_details_page_02121 {
          width: 680px;

          @media (max-width: 767px) {
            width: 100%;
          }
          .rwa_details_page_021211 {
            @media (max-width: 767px) {
              width: 100%;
            }

            video {
              width: 680px;
              height: 400px;

              @media (max-width: 767px) {
                width: 100%;
              }
            }
            video::-webkit-media-controls {
              display: flex !important;
            }
            video::-webkit-media-controls-play-button,
            video::-webkit-media-controls-volume-slider,
            video::-webkit-media-controls-mute-button,
            video::-webkit-media-controls-timeline,
            video::-webkit-media-controls-current-time-display,
            video::-webkit-media-controls-time-remaining-display {
              display: block !important;
            }
          }
          .rwa_details_page_021212 {
            color: #FFF;
            font-family: "Microsoft YaHei";
            font-size: 24px;
            font-style: normal;
            font-weight: 700;
            line-height: 32px; /* 133.333% */
            margin: 15px 0;
          }
          .rwa_details_page_021213 {
            width: 680px;
            margin-bottom: 20px;

            @media (max-width: 767px) {
              width: 100%;
            }
          }
          .rwa_details_page_021214 {
            width: 680px;
            height: 350px;
            margin-bottom: 30px;
            text-align: center;
            background: #0A0A0A;

            @media (max-width: 767px) {
              width: 100%;
            }
            img {
              height: 350px;
            }
          }
          .rwa_details_page_021215 {
            .rwa_details_page_0212151 {
              color: #FFF;
              font-family: "Microsoft YaHei";
              font-size: 24px;
              font-style: normal;
              font-weight: 700;
              line-height: 32px; /* 133.333% */
              margin-bottom: 15px;
            }
            .rwa_details_page_0212152 {
              color: white;
            }
          }
        }
        .rwa_details_page_02122 {
          width: 350px;
          display: flex;
          padding: 20px 15px;
          flex-direction: column;
          align-items: flex-start;
          gap: 16px;
          flex: 1 0 0;
          border-radius: 16px;
          background: #313231;

          @media (max-width: 767px) {
            width: 90%;
          }
          .rwa_details_page_021221 {
            color: #FFF;
            font-family: Roboto;
            font-size: 20px;
            font-style: normal;
            font-weight: 700;
            line-height: 28px; /* 140% */
            align-self: stretch;
            border-bottom: 1px solid #666666;
            height: 45px;
          }
          .rwa_details_page_021222 {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: space-between;
            align-items: center;
            color: #999;
            font-family: Roboto;
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: 20px; /* 142.857% */

            @media (max-width: 767px) {
              width: 100%;
            }
            .rwa_details_page_0212221 {
              width: 95px;

              @media (max-width: 767px) {
                width: 110px;
              }
            }
            .rwa_details_page_0212222 {
              width: 100px;

              @media (max-width: 767px) {
                width: 120px;
              }
            }
            .rwa_details_page_0212223 {
              width: 130px;

              @media (max-width: 767px) {
                width: 150px;
              }
            }
          }
          .rwa_details_page_021223 {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: space-between;
            align-items: center;
            color: #FFF;
            font-family: Roboto;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 20px; /* 142.857% */

            @media (max-width: 767px) {
              font-size: 16px;
              width: 100%;
            }
            .rwa_details_page_0212231 {
              width: 95px;

              @media (max-width: 767px) {
                width: 110px;
              }
            }
            .rwa_details_page_0212232 {
              width: 100px;

              @media (max-width: 767px) {
                width: 120px;
              }
            }
            .rwa_details_page_0212233 {
              width: 130px;

              @media (max-width: 767px) {
                width: 150px;
              }
            }
          }
        }
      }
    }
    .rwa_details_page_03 {
      width: 100%;
    }
  }
}
</style>

<style>
.rwa_details_div {
  .el-input__inner {
    border-radius: 4px !important;
    border: 1px solid rgba(153, 153, 153, 0.20) !important;
    background: #363636 !important;
    color: #cbcbcb !important;
  }

  .el-input-number.is-controls-right .el-input__inner:hover {
    border: 1px solid #20944B !important;
  }
  .el-input-number.is-controls-right .el-input__inner:not(.is-disabled) {
    border: 1px solid #20944B !important;
  }
  .el-input-number.is-controls-right .el-input-number__increase:hover {
    color: #20944B !important;
  }
  .el-input-number.is-controls-right .el-input-number__decrease:hover {
    color: #20944B !important;
  }

  .el-input-number__increase {
    background: #2e2e2e;
    border-left: 1px solid #20944B !important;
    border-bottom: 1px solid #20944B !important;
  }

  .el-input-number__decrease {
    background: #2e2e2e;
    border-left: 1px solid #20944B !important;
  }
  .el-input-number__decrease, .el-input-number__increase {
    color: #cbcbcb !important;
  }

  .el-notification {
    width: 410px !important;
  }
}
</style>